<template>
  <v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
    <v-card class="pa-3">
      <div class="text-subtitle-2 mb-2">{{ $t("board.send_template_title") }}</div>
      <v-select v-model="selected" :items="templates" item-text="name" return-object
        :label="$t('board.template')" :loading="loading" hide-details dense clearable />
      <v-checkbox v-model="channels.email" label="Email" hide-details dense class="mt-2" />
      <v-checkbox v-model="channels.whatsapp" label="WhatsApp" hide-details dense />
      <v-checkbox v-model="channels.sms" label="SMS" hide-details dense />
      <div class="d-flex justify-end mt-2">
        <v-btn text small @click="$emit('input', false)">{{ $t("custom.cancel") }}</v-btn>
        <v-btn color="primary" small :loading="sending"
          :disabled="!selected || (!channels.email && !channels.whatsapp && !channels.sms)" @click="send">
          {{ $t("custom.send") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BookingBoardTemplateDialog",
  props: {
    value: { type: Boolean, default: false },
    booking: { type: Object, default: null },
  },
  data() {
    return {
      templates: [],
      selected: null,
      loading: false,
      sending: false,
      channels: { email: true, whatsapp: true, sms: false },
    };
  },
  watch: {
    value(open) {
      if (open) {
        this.selected = null;
        this.channels = { email: true, whatsapp: true, sms: false };
        this.loadTemplates();
      }
    },
  },
  methods: {
    authHeaders() {
      return { headers: { Authorization: this.$store.getters.getAuthToken } };
    },
    loadTemplates() {
      this.loading = true;
      this.axios
        .get("/api/v1/email_templates", this.authHeaders())
        .then((r) => { this.templates = r.data; })
        .catch((e) => this.setError && this.setError(e, this.$t("errors.email_template_text")))
        .finally(() => (this.loading = false));
    },
    send() {
      if (!this.selected || !this.booking) return;
      const c = this.channels;
      this.sending = true;
      this.axios
        .post(
          `/api/v1/send_custom_email?email=${c.email}&whatsapp=${c.whatsapp}&sms=${c.sms}`,
          {
            id: this.booking.id,
            name: this.selected.name,
            subject: this.selected.subject,
            body: this.selected.body,
          },
          this.authHeaders()
        )
        .then(() => {
          this.$notify(this.$t("bookings.send_email_success"), "", "success", 3000);
          this.$emit("input", false);
          this.$emit("sent");
        })
        .catch((e) => this.setError && this.setError(e, this.$t("errors.email_bad_send")))
        .finally(() => (this.sending = false));
    },
  },
};
</script>
